import { get } from 'api/request';
import urls from 'configs/urls';

export const getConfigurations = () => get(null, false, `${urls.common.getConfigurations}`);
